import React from "react";
import { WHATSAPP_RDV_URL } from "../../utils/whatsapp";
import Valuessection from "../HomePage/Valuessection"
import aboutimg from "../../assets/images/appImages/about1.jpg"
import founderPortrait from "../../assets/images/appImages/FOUTA BIO AHMAD SITE.png"

interface FounderStep {
  icon: string;
  title: string;
  description: string;
}

interface Engagement {
  text: string;
}

const founderSteps: FounderStep[] = [
  {
    icon: "bi-compass",
    title: "Une vocation portée par la volonté d'aider",
    description:
      "Dès le départ, Ahmad Ba est guidé par une conviction : lorsqu'on accompagne les autres, on ne peut jamais considérer que l'on sait déjà assez.",
  },
  {
    icon: "bi-airplane",
    title: "Un départ en Égypte",
    description:
      "Pour approfondir ses connaissances en médecine prophétique et phytothérapie, Ahmad Ba se rend en Égypte, un carrefour du savoir traditionnel et islamique.",
  },
  {
    icon: "bi-book",
    title: "Un apprentissage continu",
    description:
      "Médecine prophétique, phytothérapie et pratiques complémentaires — une formation continue à travers les lectures, les recherches, les rencontres et les voyages.",
  },
  {
    icon: "bi-house-door",
    title: "Un retour au Sénégal",
    description:
      "Ahmad Ba revient pour mettre ce savoir au service de son environnement, avec la volonté de proposer une approche sérieuse, éthique et accessible.",
  },
];

const engagements: Engagement[] = [
  { text: "Ne pas promettre de guérison ou de résultat garanti." },
  { text: "Ne pas encourager l'arrêt d'un traitement ou d'un suivi médical." },
  { text: "Expliquer les limites et les précautions de chaque pratique ou produit." },
  { text: "Vérifier les références religieuses avant de les présenter." },
  { text: "Protéger la confidentialité des personnes accompagnées." },
];

const HeroSection: React.FC = () => {
  return (
    <section id="a-propos" className="fb-hero py-5">
      <div className="container py-4">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <p className="fb-eyebrow">À PROPOS DE FOUTA BIO</p>
            <h1 className="fb-title mb-4">
              Une structure
              <br />
              spécialisée,
              <br />
              <em className="fb-title-accent">une approche globale.</em>
            </h1>
            <p className="fb-text mb-3">
              Fouta Bio est une structure spécialisée dans la phytothérapie, la
              médecine prophétique, la Hijama et la Roqya conforme aux
              principes islamiques.
            </p>
            <p className="fb-text">
              Notre objectif est de valoriser les savoirs traditionnels tout
              en accordant une importance particulière à l'écoute, à
              l'hygiène, à la qualité des produits et au respect de chaque
              personne.
            </p>
          </div>
          <div className="col-lg-6">
            <div className="fb-hero-image">
              <img
                src={aboutimg}
                alt="Flacons et herbes de phytothérapie"
                className="img-fluid rounded-4"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const MissionSection: React.FC = () => {
  return (
    <section className="fb-mission py-5">
      <div className="container py-4">
        <div className="row justify-content-center text-center">
          <div className="col-lg-9">
            <p className="fb-eyebrow justify-content-center">NOTRE MISSION</p>
            <h2 className="fb-heading-2 mb-4">
              Rendre les savoirs plus accessibles, sans jamais sacrifier le
              sérieux
            </h2>
            <p className="fb-text mb-3">
              Rendre les savoirs liés à la médecine prophétique et à la
              phytothérapie plus accessibles, tout en les présentant avec
              sérieux, éthique, pédagogie et responsabilité.
            </p>
            <p className="fb-text">
              Nous ne réduisons pas une personne à un symptôme ou à une seule
              explication. Nous commençons par écouter, poser des questions et
              considérer les différentes dimensions de ce qu'elle vit avant de
              proposer une orientation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const FounderSection: React.FC = () => {
  return (
    <section className="fb-founder py-5">
      <div className="container py-4">
        <div className="text-center mb-5">
          <p className="fb-eyebrow fb-eyebrow-light justify-content-center">
            LE FONDATEUR
          </p>
          <h2 className="fb-founder-name mb-2">Ahmad Ba</h2>
          <p className="fb-founder-subtitle">
            Fondateur de Fouta Bio - Spécialiste en médecine prophétique
          </p>
        </div>

        <div className="row align-items-stretch g-4 mb-5">
          <div className="col-lg-6">
            <div className="d-flex flex-column gap-3 h-100">
              {founderSteps.map((step, idx) => (
                <div className="fb-step-card" key={idx}>
                  <div className="d-flex align-items-start gap-3">
                    <div className="fb-step-icon">
                      <i className={`bi ${step.icon}`}></i>
                    </div>
                    <div>
                      <h3 className="fb-step-title">{step.title}</h3>
                      <p className="fb-step-desc mb-0">{step.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="fb-founder-image h-100">
              <img
                src={founderPortrait}
                alt="Ahmad Ba, fondateur de Fouta Bio"
                className="img-fluid rounded-4 h-100 w-100"
                style={{ objectFit: "cover", objectPosition: "top center" }}
              />
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <blockquote className="fb-quote">
              <p className="mb-4">
                « Notre ambition est de proposer une approche sérieuse,
                éthique et responsable de la médecine traditionnelle et de la
                médecine prophétique. À travers la phytothérapie, la Hijama et
                la Roqya, nous souhaitons mettre à la disposition de nos
                clients des produits et des prestations fondés sur les savoirs
                traditionnels, tout en accordant une grande importance à la
                qualité, à l'hygiène et à l'écoute. Notre engagement est
                simple : travailler avec sérieux, respecter nos clients et
                continuer à nous améliorer afin de leur offrir une expérience
                professionnelle et digne de leur confiance. »
              </p>
              <footer className="fb-quote-footer">
                — Ahmad Ba, Fondateur de Fouta Bio
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

const EngagementsSection: React.FC = () => {
  return (
    <section className="fb-engagements py-5">
      <div className="container py-4">
        <div className="text-center mb-5">
          <p className="fb-eyebrow justify-content-center">ÉTHIQUE</p>
          <h2 className="fb-heading-2">Nos engagements</h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="d-flex flex-column gap-3 mb-5">
              {engagements.map((item, idx) => (
                <div className="fb-engagement-item" key={idx}>
                  <i className="bi bi-check2 fb-check-icon"></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
            <div className="text-center">
              <a
                href={WHATSAPP_RDV_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn fb-btn-primary fb-btn-lg"
              >
                Prendre rendez-vous
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const AboutPage: React.FC = () => {
  return (
    <div className="fb-page">
      <HeroSection />
      <MissionSection />
      <FounderSection />
      <Valuessection />
      <EngagementsSection />
    </div>
  );
};

export default AboutPage;